// extracted by mini-css-extract-plugin
module.exports = {"horizontal-group":"_3ea6fa5da8--horizontal-group--o1T8f","vertical-group":"_3ea6fa5da8--vertical-group--kz0pR"};